module.exports = __webpack_public_path__ + "img/2_1.4fb74e62.jpg";